import React, { useEffect, useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";
import { Label } from "abs-ui-components";
import axiosHttp from "../../../services/interceptor";

const baseURL = process.env.REACT_APP_BASE_URL;

const UKMETSFormGroup = ({vesselData,reportStatus}) => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	const [monitoringPlanStatusOptions, setMonitoringPlanStatusOptions] = useState([]);

	useEffect(() => {
		const getMonitoringPlanStatus = async () => {
			try {
				const response = await axiosHttp.get(
					`${baseURL}api/MasterData/GetUkEtsMonitoringPlanStatus`
				);

				if (response?.data) {
					const data = response.data?.data ?? response.data ?? [];

					setMonitoringPlanStatusOptions(
						Array.isArray(data)
							? data.map((item) => ({
								label: item.Value,
								value: item.UkEtsMonitoringPlanStatusMstId,
							}))
							: []
					);
				}
			} catch (error) {
				console.error(
					"Error fetching UK ETS Monitoring Plan Status",
					error
				);
			}
		};

		getMonitoringPlanStatus();
	}, []);

	return (
		<div className="container-fluid p-0 m-0">
			<MDBRow>
				<MDBCol md="12" className="mt-3">
					<Label
						required
						bold
						name="Monitoring Plan Status"
						className="mb-1"
					/>

					<Controller
						name="ukMets.monitoringPlanStatus"
						control={control}
						defaultValue={vesselData?.UkEtsMonitoringPlanStatusMstId ?? ""}
						rules={{
							required: "Monitoring Plan Status is required",
						}}
						render={({ field }) => (
							<select
								name={field.name}
								ref={field.ref}
								value={field.value || ""}
								onBlur={field.onBlur}
								onChange={(event) => {
									field.onChange(
										event.target.value
											? Number(event.target.value)
											: ""
									);
								}}
								disabled={reportStatus?.trim() === "Verification Completed"}
								className="form-control uk-mets-dropdown"
							>
								<option value="">
									-- Select Monitoring Plan Status --
								</option>

								{monitoringPlanStatusOptions.map((option) => (
									<option
										key={option.value}
										value={option.value}
									>
										{option.label}
									</option>
								))}
							</select>
						)}
					/>

					{errors.ukMets?.monitoringPlanStatus && (
						<div className="error-msg">
							{errors.ukMets.monitoringPlanStatus.message}
						</div>
					)}
				</MDBCol>
			</MDBRow>
		</div>
	);
};

export default UKMETSFormGroup;